// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bearNetworkChainTestnet as _bearNetworkChainTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bearNetworkChainTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 751230
 * Chain Name: Bear Network Chain Testnet
 * Default Block Explorer: https://brnktest-scan.bearnetwork.net
 * Default RPC URL: https://brnkc-test.bearnetwork.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bearNetworkChainTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bearNetworkChainTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bearNetworkChainTestnet = createCommon({
	..._bearNetworkChainTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
